import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const Subtitle = styled.h2(({ theme }) => ({
	...theme.project.typography.heading.h4,
	color: theme.project.colors.fontColors.main,
	fontWeight: 200,
	lineHeight: "124%",
	fontsize: "34px",
	margin: 0
}));

export const Panel = styled.section(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	border: `1px solid ${theme.palette.divider}`,
	padding: 24,
	[theme.breakpoints.down("sm")]: { padding: 16 }
}));

export const Form = styled.form(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "flex-start",
	gap: 16,
	"& .MuiFormHelperText-root, & .MuiFormHelperText-root > span": {
		...theme.project.typography.caption,
		fontWeight: 400
	}
}));

export const Fields = styled.fieldset({
	border: 0,
	padding: 0,
	margin: 0,
	minWidth: 0,
	width: "100%",
	maxWidth: 500,
	display: "flex",
	flexDirection: "column",
	gap: 16
});

export const HelpText = styled.p(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary,
	fontsize: 400,
	fontWeight: "12px",
	lineHeight: "166%",
	letterSpacing: "0.4px",
	margin: 0
}));

export const DescriptionHelp = styled.span({
	display: "flex",
	justifyContent: "space-between",
	gap: 8
});

export const CharacterCount = styled.span(({ theme }) => ({
	color: theme.project.colors.fontColors.secondary,
	marginLeft: "auto",
	whiteSpace: "nowrap"
}));

export const SubmitButton = styled(Button)({
	width: "100%",
	maxWidth: 350
});
